import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";

@Injectable({
  providedIn: "root",
})
export class ExchangeRateService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  getExchangeRateBetweeCurrencies(base: string, target: string, isStatisticsCurrency = false) {
    const apiUrl = `${this.apiUrl}/api/Bill/exchange-rate/${base}/${target}?isStatisticsCurrency=${isStatisticsCurrency}`;
    return this.http.get<number>(apiUrl);
  }

  getCurrencySymbol(currency: string): string {
    switch (currency.toUpperCase()) {
      case "RSD":
        return "Din";
      case "EUR":
        return "€";
      case "BAM":
        return "KM";
      case "USD":
        return "$";
      case "ALL":
        return "L";
      case "MKD":
        return "ден";
      case "AUD":
        return "A$";
      case "CAD":
        return "C$";
      case "CNY":
        return "¥";
      case "CZK":
        return "Kč";
      case "DKK":
        return "kr";
      case "HUF":
        return "Ft";
      case "INR":
        return "₹";
      case "JPY":
        return "¥";
      case "KWD":
        return "KD";
      case "NOK":
        return "kr";
      case "RUB":
        return "₽";
      case "SEK":
        return "kr";
      case "CHF":
        return "CHF";
      case "AED":
        return "د.إ";
      case "GBP":
        return "£";
      case "BYN":
        return "Br";
      case "RON":
        return "lei";
      case "TRY":
        return "₺";
      case "BGN":
        return "лв";
      case "PLN":
        return "zł";
      case "ATS":
        return "S";
      case "BEF":
        return "FB";
      case "FIM":
        return "mk";
      case "FRF":
        return "₣";
      case "DEM":
        return "DM";
      case "GRD":
        return "₯";
      case "IEP":
        return "£";
      case "ITL":
        return "L";
      case "LUF":
        return "F";
      case "PTE":
        return "Esc";
      default:
        return "";
    }
  }
}
